import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { Box, Button, Tooltip } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';

import { copyButtonStyles } from './styles';

const CopyButton = ({
  value, titleCopiedText = 'Copied!', titleText = 'Copy information', children,
}) => {
  const [copied, copy] = useCopyToClipboard();

  const handleClick = (e) => {
    e.stopPropagation();
    copy(value);
  };

  const openTooltip = Boolean(copied);
  const title = openTooltip ? t(titleCopiedText) : t(titleText);

  const buttonContent = !children ? (
    <Button onClick={handleClick}>
      <ContentCopy />
    </Button>
  ) : React.cloneElement(children, { onClick: handleClick });

  return (
    <Box className="dn-copy-button" sx={copyButtonStyles}>
      <Tooltip title={title}>
        {buttonContent}
      </Tooltip>
    </Box>
  );
};

CopyButton.propTypes = {
  value: PropTypes.string.isRequired,
  titleText: PropTypes.string,
  titleCopiedText: PropTypes.string,
  children: PropTypes.node,
};

export default memo(CopyButton);
